import { isIOS, isMobile, isTablet, isAndroid } from 'react-device-detect';
import { FTUE_STEPS_KEYS } from 'shared/constants';
import styled from 'styled-components';
import { isNotStandaloneMobilePWA } from '../../utils/mobileSupported';

const viewportWidth = window.innerWidth;
const vwInPixels = viewportWidth / 100;
const GAME_TILE_WIDTH = 16 * vwInPixels;
const iPadMini = isTablet && viewportWidth < 1420 && !isAndroid;

const getScrollBarConfig = (ftueStep, gameIndex, hasPromotions, totalGamesCount, showBanner, lobbyPromotionsLength, lobbyBannersLength) => {
  const maxVisibleGames = isMobile ? 0 : 8;
  const hasMoreGamesThanVisible = totalGamesCount > maxVisibleGames;
  const bannersAffectScroll = showBanner && (totalGamesCount > 2 || lobbyBannersLength > 1);
  return {
    isDraggableX: true,
    showVertical: false,
    showHorizontal: hasMoreGamesThanVisible || bannersAffectScroll,
    showHorizontalArrows: false,
    showByDefault: true,
    hideScrollbars: isMobile,
    scrollToPosition: ftueStep === FTUE_STEPS_KEYS.HIGHLIGHT_A_GAME || showBanner ? 0 : gameIndex * GAME_TILE_WIDTH,
    customStyle: {
      display: 'flex',
      height: '100%',
      paddingTop: '1vh',
      paddingLeft: hasPromotions
        ? lobbyPromotionsLength > 1
          ? '30dvw'
          : isNotStandaloneMobilePWA && !isTablet
            ? '27dvw'
            : '31.5dvw'
        : '8dvw',
    },
    customWidth: isNotStandaloneMobilePWA ? '100%' : '97dvw',
    ...(isNotStandaloneMobilePWA && {
      containerStyle: {
        overflowX: 'scroll',
        width: '100vw',
        minWidth: '100vw',
      },
    }),
    customClassNames: isIOS
      ? 'custom-scrollbar'
      : `${hasPromotions ? 'custom-scrollbar-gamepage' : 'custom-scrollbar-gamepage custom-scrollbar-gamepage-no-promo-banner'}`,
  };
};

const MainContainer = styled.div`
  display: flex;
  padding-bottom: 2rem;

  @media only screen and (max-height: 780px) {
    padding-bottom: 3rem;
  }

  ${isTablet && !isAndroid && `padding-bottom: ${viewportWidth < 1200 ? 0 : viewportWidth < 1250 ? 1 : iPadMini ? 2 : 1}rem !important;`}
`;

export { getScrollBarConfig, MainContainer };

